import { useAtom } from "jotai";
import { StepAtom } from "./atoms";
import { StepResult } from "./stepResult";
import { Step1 } from "./step1";
import * as React from "react";
import { Step2 } from "./step2";
import { Step3 } from "./step3";
import { Step4 } from "./step4";
import { steps } from "./useNav";
import { useEffect } from "react";

export function Step() {
  const [step] = useAtom(StepAtom);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  if (step === steps.StepResult) {
    return <StepResult />;
  }
  if (step === steps.Step1) {
    return <Step1 />;
  }
  if (step === steps.Step2) {
    return <Step2 />;
  }
  if (step === steps.Step3) {
    return <Step3 />;
  }
  if (step === steps.Step4) {
    return <Step4 />;
  }
  return <div className="Step">There is no step</div>;
}
